import React from "react";
import { RouteObject } from "react-router";

export const FinanceRoutes: RouteObject[] = [
  {
    path: "payments",
    async lazy() {
      const { Reports } = await import("src/finance/Reports");
      return { element: <Reports /> };
    },
  },
  {
    path: "deposits",
    async lazy() {
      const { Reports } = await import("src/finance/Reports");
      return { element: <Reports /> };
    },
  },
  {
    path: "chargebacks",
    async lazy() {
      const { Reports } = await import("src/finance/Reports");
      return { element: <Reports /> };
    },
  },
  {
    path: "",
    async loader(args) {
      const { financeTabLoader } = await import("src/router/loaders");
      return financeTabLoader(args);
    },
  },
];
